export default function () {
  const selector = '#onetrust-consent-sdk';

  // on some user interaction show the consent banner
  const events = [
    'click',
    'touchstart',
    'scroll',
    'keydown',
    'mousemove',
  ];

  // register listeners once
  events.forEach((event) => {
    window.addEventListener(event, () => {
      const el = document.querySelector(selector);

      if (el) {
        el.classList.add('onetrust-consent-sdk--show');
      }
    }, { once: true });
  });
}
